module.exports = __webpack_public_path__ + "img/logo.5d982453.png";